import { render, staticRenderFns } from "./DeleteVirtualUserModal.vue?vue&type=template&id=3727b37d&"
import script from "./DeleteVirtualUserModal.vue?vue&type=script&lang=js&"
export * from "./DeleteVirtualUserModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports